import { render, staticRenderFns } from "./DetailsQuote.vue?vue&type=template&id=0e5bd6a3&"
import script from "./DetailsQuote.vue?vue&type=script&lang=js&"
export * from "./DetailsQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports